<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <input type="email" class="form-control" :class="errorMessage ? 'is-invalid' : ''" v-model="value">
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem';
import FormLayout from '@/views/templates/FormLayout'

export default {
  name: "VuexEmailFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
  },
  components: {
    FormLayout,
  },
}
</script>
